import { render } from "./DistributorView.vue?vue&type=template&id=da3f8360"
import script from "./DistributorView.vue?vue&type=script&lang=js"
export * from "./DistributorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__